
  <div class="controls">
    <div class="minus" (click)="onMinus()">
      -
    </div>
    <div class="plus" (click)="onPlus()">
      +
    </div>
  </div>
  <div class="input-wrapper">
    <input type="number" value="0" #number (change)="onNumberChange($event)">
    <div class="unit">
      %
    </div>
  </div>
